module.exports = __webpack_public_path__ + "static/15.WINNER'S.LOGOS_jess.whitwell-8a20cfe4d1aa5e0948e6e9362f9ba6ec.png";